// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"380":"59113102","453":"d212c517","839":"a7f8149e","941":"13138941"}[chunkId] + ".chunk.js";
};